import { CategoryPageTemplate } from './CategoryPageTemplate'

export function FaceAestheticPage() {
  return <CategoryPageTemplate categoryKey="faceAesthetic" namespace="faceAesthetic" />
}
